import type { SessionInfo } from "@opencode/client/promise"
import type { useLanguage } from "@/runtime/i18n/language"

const pattern = /^(New session|Child session) - \d{4}-\d{2}-\d{2}T\d{2}:\d{2}:\d{2}\.\d{3}Z$/

export function sessionLabel(
  session: Pick<SessionInfo, "title" | "parentID">,
  translate: ReturnType<typeof useLanguage>["t"],
) {
  return (
    sessionTitle(session.title, translate) ||
    translate(session.parentID ? "session.title.child" : "command.session.new")
  )
}

export function sessionTitle(title: string | undefined, translate: ReturnType<typeof useLanguage>["t"]) {
  if (!title) return title
  const match = title.match(pattern)
  if (!match) return title
  return translate(match[1] === "Child session" ? "session.title.child" : "command.session.new")
}
